<template>
  <h-frame type="left">
    <div class="threeSolidLeft">
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            车辆颜色
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <housingLeftOne></housingLeftOne>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            布控车辆告警
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <housingLeftTwo></housingLeftTwo>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            频繁出没
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <housingLeftThree></housingLeftThree>
      </div>
      <!-- <div class="echarts" id="echartsbottomLeft"></div> -->
    </div>
  </h-frame>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
// import * as echarts from "echarts";
import housingLeftOne from "./housingLeftOne";
import housingLeftTwo from "./housingLeftTwo";
import housingLeftThree from "./housingLeftThree";
// import threeechartsone from "./threeechartsone";
import { prisonHouseHoldType } from "@/api/threeSolid/threeSolidHome.js";

export default defineComponent({
  name: "",
  components: {
    housingLeftOne,
    housingLeftTwo,
    housingLeftThree
    // threeechartsone
  },
  props: {},
  setup(props) {
    const data = reactive({
      leftList: [
        { name: "人口", value: "123", icon: "icon-tianjia1", id: "1" },
        { name: "房屋", value: "25", icon: "icon-tianjia1", id: "2" },
        { name: "单位", value: "47", icon: "icon-tianjia1", id: "3" },
        { name: "警情事件", value: "523", icon: "icon-tianjia1", id: "4" },
        { name: "安防设施", value: "12", icon: "icon-tianjia1", id: "5" },
        { name: "力量装备", value: "32", icon: "icon-tianjia1", id: "6" }
      ]
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const res = await prisonHouseHoldType();
      console.log("numberall ~ res", res);
    };
    numberall();
    // echarts

    return { ...refData };
  }
});
</script>
<style lang="scss" scoped>
.threeSolidLeft {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 15px;
  overflow: auto;
  color: white;
  .titleWidth {
    width: 100%;
  }
  .itemDetail {
    height: 33%;
  }
  .leftpeople {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .yellowColor {
      width: 100%;
      text-align: center;
      color: #f3ce61;
      line-height: 40px;
    }
    .peopleecharts {
      display: flex;
      flex-direction: column;

      .oneBox {
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        .bluecolore {
          color: #91c8ff;
        }
      }
      .oneBluebg {
        width: 100%;
        height: 30px;
        background: rgba(0, 143, 187, 1);
        border-radius: 4px;
        position: relative;

        .bluecount {
          width: 200px;
          text-align: center;
          height: 100%;
          position: absolute;
          border-radius: 4px;
          box-shadow: 0 0 10px 3px #00c9fa inset;
          background: #00a8ec;
          z-index: 2;
          line-height: 30px;
        }
        .noBlue {
          position: absolute;
          right: 20px;
          line-height: 30px;
        }
      }
    }
  }
  //
  .titleMore {
    float: right;
    cursor: pointer;
    // margin-right: 15px;
    background: #5189b4;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 14px;
  }
}
</style>
